import { createContext } from "react"

export const AppContext = createContext(null)

export const CardGameContext = createContext(null)
